module.exports = __webpack_public_path__ + "img/htsh.fbd64da1.png";